import React, { FC, useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import Palette from '../components/palette';
import config from '../config';
import '../styles/pages/index.scss';

const AdBlock = require('react-ad-block-detect').default;

const author = config.AUTHOR;

const PageIndex: FC<{}> = () => {
   const [all, setAll] = useState([1, 2, 3, 4, 5, 6]);
   const [moreButton, setMoreButton] = useState(true);

   const loadMore = useCallback(
      (data = [1, 2, 3, 4, 5, 6]) => {
         setAll([...all, ...data]);
      },
      [all],
   );
   useEffect(() => {
      const onScroll = () => {
         const {
            scrollTop,
            scrollHeight,
            clientHeight,
         } = document.documentElement;
         if (clientHeight + scrollTop >= scrollHeight - 5) {
            loadMore();
         }
      };
      window.addEventListener('scroll', onScroll);
      return () => {
         window.removeEventListener('scroll', onScroll);
      };
   }, [loadMore]);

   return (
      <>
         <Helmet>
            <title>{config.SEO.index.title}</title>
         </Helmet>
         <div className="main-content">
            <div className="container fx fx-rnw fx-jcsa">
               <div className="palettes fx fx-aifs fx-rw fx-jcsa">
                  {all.map((v, i) => (
                     <Palette
                        key={i + '-palette'}
                        index={i + '-palette'}
                        style={{
                           animationDelay: i * 100 + 'ms',
                        }}
                        className="fadeInUp mode-both"
                     />
                  ))}

                  {moreButton && (
                     <button
                        className="button fadeInUp"
                        onClick={() => {
                           loadMore([
                              1,
                              2,
                              3,
                              4,
                              5,
                              6,
                              124123,
                              123,
                              123,
                              12,
                              31,
                              23,
                           ]);
                           setMoreButton(false);
                        }}
                        style={{
                           marginTop: 20,
                        }}
                     >
                        Load More
                     </button>
                  )}
               </div>

               <div className="sidebar fadeInsRight">
                  <div className="content">
                     <div className="container-fluid">
                        <p style={{ marginTop: 0 }}>{config.description}</p>

                        {config.ADS.blocker_detect && (
                           <AdBlock>
                              <div className="block-detect">
                                 <h3>Do you use ad blocker?</h3>
                                 <p>
                                    Support the free tools by not blocking the
                                    ad banners.
                                 </p>
                                 <Link
                                    to="/help/disable-blocker"
                                    className="button"
                                 >
                                    Disable ad blocker
                                 </Link>
                              </div>
                           </AdBlock>
                        )}

                        <div className="ads-container">
                           <a href="/" target="blank">
                              <img src="/images/ads.png" alt="" />
                           </a>
                        </div>

                        <span style={{ color: '#aaa' }}>
                           All rights reserved
                           <br />
                           <a href={author.url} target="blank">
                              &copy;&nbsp;
                              {author.name}
                           </a>
                        </span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default PageIndex;
